import React from "react";
import logo from "../Images/Aarti.jpg";
import client1 from "../Images/client1.jpg";
import client2 from "../Images/client2.jpg";
import client3 from "../Images/client3.jpg";
import client4 from "../Images/client4.jpg";
import client5 from "../Images/client5.jpg";
import client6 from "../Images/client6.jpg";
import client7 from "../Images/client7.jpg";
import client8 from "../Images/client8.jpg";
import client9 from "../Images/client9.jpg";
import client10 from "../Images/client10.jpg";
import client11 from "../Images/client11.jpg";

const AboutScroll = () => {
  return (
    <div className="bg-fixed bg-[url('./Images/Scroll.jpg')] bg-cover bg-center h-[200vh]">
      {/* First Section */}
      <div className="h-full flex flex-col justify-start pt-10 bg-[#FFFFFF]/60 backdrop-brightness-90">
        {/* === Section Heading === */}
        <h1 className="text-4xl font-bold font-sunday text-center pb-8 
          text-[#007B7F]">
          THE AURAH WAY
        </h1>

        {/* === Cards + Arrows === */}
        <div className="flex flex-col gap-[80px] overflow-hidden md:overflow-hidden px-6 relative">
          
          {/* === Card 1 === */}
          <div className="ml-0 md:ml-[200px] flex justify-center md:block">
            <div className="w-full max-w-[400px] h-auto md:h-[400px] bg-[#007B7F] rounded-xl flex flex-col items-center pt-6 shadow-lg transition-transform duration-500 hover:scale-105">
              <div className="w-16 h-16 md:w-24 md:h-24 border-4 border-dotted border-[#FAF6F1] rounded-full flex items-center justify-center text-[#FAF6F1] text-xl md:text-3xl font-bold">
                01
              </div>
              <p className="mt-6 md:mt-[40px] mx-4 font-poppins text-justify text-[#FAF6F1] text-[15px] md:text-[17px] px-2 md:px-4">
                Tell us what your dream looks like whether it's a candlelit honeymoon in the Maldives, a luxury corporate retreat in the Swiss Alps, or an opulent destination wedding in Tuscany. We listen, understand, and begin crafting an experience that is uniquely yours.
              </p>
            </div>
          </div>


          {/* === Arrow 1 (hidden on mobile) === */}
          <svg
            className="hidden md:block absolute left-[580px] top-[320px]"
            width="400"
            height="200"
            viewBox="0 0 400 200"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <marker
                id="arrowhead1"
                markerWidth="24"
                markerHeight="16"
                refX="20"
                refY="8"
                orient="auto"
                markerUnits="userSpaceOnUse"
              >
                <polygon points="0 0, 24 8, 0 16" fill="black" />
              </marker>
            </defs>
            <path
              d="M0 80 Q 175 200, 200 100 T 399 160"
              stroke="black"
              strokeWidth="3"
              strokeDasharray="6,6"
              fill="none"
              markerEnd="url(#arrowhead1)"
              className="animate-draw-dotted-loop"
            />
          </svg>

          {/* === Card 2 === */}
          <div className="self-end md:mr-40 mx-auto md:mx-0">
            <div className="w-full max-w-[400px] h-auto md:h-[400px] bg-[#007B7F] rounded-xl flex flex-col items-center pt-6 shadow-lg transition-transform duration-500 hover:scale-105">
              <div className="w-16 h-16 md:w-24 md:h-24 border-4 border-dotted border-[#FAF6F1] rounded-full flex items-center justify-center text-[#FAF6F1] text-xl md:text-3xl font-bold">
                02
              </div>
              <p className="mt-6 md:mt-[40px] mx-4 font-poppins text-justify text-[#FAF6F1] text-[15px] md:text-[17px] px-2 md:px-4">
                From handpicked hotels and seamless itineraries to exclusive local experiences, our team meticulously curates every aspect of your journey. No detail is too small — your travel dreams are transformed into a flawless, indulgent reality.
              </p>
            </div>
          </div>



          {/* === Arrow 2 (hidden on mobile) === */}
          <svg
            className="hidden md:block absolute left-[530px] top-[765px]"
            width="600"
            height="300"
            viewBox="0 0 600 400"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <marker
                id="arrowhead2"
                markerWidth="24"
                markerHeight="24"
                refX="0"
                refY="7"
                orient="auto"
                markerUnits="userSpaceOnUse"
              >
                <polygon points="0 0, 24 8, 0 16" fill="black" />
              </marker>
            </defs>
            <path
              d="M580 155 Q 500 400, 200 200 T 20 240"
              stroke="black"
              strokeWidth="4"
              strokeDasharray="9,6"
              fill="none"
              markerEnd="url(#arrowhead2)"
              className="animate-draw-dotted-loop"
            />
          </svg>

          {/* === Card 3 === */}
          <div className="w-full flex justify-center md:justify-start pb-10">
            <div className="ml-0 md:ml-[400px] mt-0 md:mt-[1px] w-full max-w-[400px] h-auto md:h-[400px] bg-[#007B7F] rounded-xl flex flex-col items-center pt-6 shadow-lg transition-transform duration-500 hover:scale-105">
              <div className="w-16 h-16 md:w-24 md:h-24 border-4 border-dotted border-[#FAF6F1] rounded-full flex items-center justify-center text-[#FAF6F1] text-xl md:text-3xl font-bold">
                03
              </div>
              <p className="mt-6 md:mt-[40px] mx-4 font-poppins text-justify text-[#FAF6F1] text-[15px] md:text-[17px] px-2 md:px-4">
                All you have to do is arrive. Every moment has been tailored to perfection, leaving you to soak in the luxury, the emotion, and the memories — all without lifting a finger. With Aurah, you don't just travel. You experience magic.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* SECTION 2: Woman Behind Aurah */}
      <section className="font-belleza">
        {/* === CONTENT CARD === */}
        <div className="max-w-6xl mx-auto mt-12 bg-white shadow-md p-8 md:flex md:items-center md:gap-12">
          {/* LEFT CIRCLE IMAGE */}
          <div className="w-full md:w-1/2 flex justify-center mb-6 md:mb-0">
            <img
              src={logo}
              alt="Aurah Scenic Icon"
              className="w-60 h-60 md:w-81 md:h-81 rounded-full object-cover border border-gray-300"
            />
          </div>

          {/* RIGHT TEXT CONTENT */}
          <div className="w-full md:w-1/2 text-left">
            <h2 className="text-2xl md:text-3xl text-[#14767E] uppercase tracking-wider font-perandory">
              Meet the Founder - Aarti Aggarwal
            </h2>

            <p className="text-gray-800 mt-4 leading-relaxed font-sans">
              I founded Aurah Leisure over a decade ago with a simple intention: to make travel planning as thoughtful,
              effortless, and fulfilling as the journeys themselves. What began as a personal passion has grown into a
              boutique travel consultancy built almost entirely on referrals and returning clients — a community I've had
              the privilege of serving for years.
            </p>

            <p className="text-gray-800 mt-4 leading-relaxed font-sans">
              With over 100 trips crafted and 80% of our business coming from repeat guests, I believe what sets Aurah apart
              is a truly personal approach. I don't just plan itineraries — I design experiences that reflect your pace, your
              preferences, and your story. Whether it's a milestone celebration, a family getaway, a honeymoon, or a corporate
              retreat, I treat every trip with the same care and intention I would my own.
            </p>

            <p className="text-gray-800 mt-4 leading-relaxed font-sans">
              Many of my clients have trusted me with their travels for more than a decade, and that loyalty is something I hold
              close. If you're new to Aurah, consider this your invitation to experience travel that feels considered, calm, and
              completely custom — with a dedicated partner by your side every step of the way.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3: Our Clients */}
      <section className="py-16 px-6">
        <h2 className="text-2xl md:text-4xl text-[#425043] font-anton text-center mb-12">
          OUR CLIENTS
        </h2>

        <div id="clients" className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-8 justify-items-center">
          {[
            client1,
            client2,
            client3,
            client4,
            client5,
            client6,
            client7,
            client8,
            client9,
            client10,
            client11,
          ].map((logo, i) => (
            <div key={i} className="w-[100px] h-[100px] md:w-[140px] md:h-[140px] flex items-center justify-center">
              <img
                src={logo}
                alt={`Client ${i + 1}`}
                className="max-w-full max-h-full object-contain"
              />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default AboutScroll;
